import DictionaryListPresentation from 'components/DictionaryList/DictionaryListPresentation'

export default {
  Presentation: DictionaryListPresentation,
}
